export const wizardSteps = {
    StepOne: 1,
    StepTwo: 2,
    StepThree: 3,
    StepFour: 4,
    StepFive:5,
    StepSix:6,

};
